export default __webpack_public_path__ + "static/media/21.8df9ffd2.png";